import { type UUID } from 'node:crypto';

import { ENDPOINT } from '~/constants/endpoints';

import { vestigasApi } from '~/services/kyClient';

import {
  type UpdateCustomFieldPayload,
  type UpdateCustomFieldResponse,
} from './types';
import { zodUpdateCustomFieldPayloadSchema } from './validations';

/**
 * Updates a custom field.
 *
 * @param customFieldId - The unique identifier (UUID) of the custom field that needs to be updated.
 * @param customFieldData - An object containing the custom field. details to be updated.
 * @returns A promise that resolves with the API response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Custom-Field/operation/update_custom_field_custom_field__custom_field_id__put
 */
export const updateCustomField = async (
  customFieldId: UUID,
  customFieldData: UpdateCustomFieldPayload,
) => {
  const response = await vestigasApi
    .put(ENDPOINT.CUSTOM_FIELD.UPDATE(customFieldId), {
      json: customFieldData,
      validate: {
        body: zodUpdateCustomFieldPayloadSchema,
      },
    })
    .json<UpdateCustomFieldResponse>();

  return response;
};
